import React from 'react';
import type { FC } from 'react';
import { Box } from 'ink';
import { RadioIcon } from '../../icons/index.js';
import { Text } from '../Text.js';

interface Props {
  isSelected?: boolean;
}

export const Indicator: FC<Props> = ({ isSelected }) => {
  return (
    <Box width={2}>
      <Text skin="info">
        <RadioIcon selected={isSelected} />
      </Text>
    </Box>
  );
};
